import { RouteObject } from "react-router-dom";
import { PublicRoutes } from "./PublicRoutes";
import { MemberRoutes } from "./MemberRoutes";
import { StaffRoutes } from "./StaffRoutes";

import { protectRoutes } from "../components/Auth/ProtectedRoute";
import { StaffLegacyRoutes } from "./StaffLegacyRoutes";
import { MemberLegacyRoutes } from "./MemberLegacyRoutes";
import { PublicLegacyRoutes } from "./PublicLegacyRoutes";
import { AccessTypeWithStaff } from "../Enums/UserEnums";
import { SuperAdminRoutes } from "./SuperAdminRoutes";
import NotFound from "../components/NotFound";
import { AdminLegacyRoutes } from "./AdminLegacyRoutes";
import { DataAdminRoutes } from "./DataAdminRoutes";

const validateDuplicatePaths = (routes: RouteObject[]): void => {
  const pathMap = new Map<string, string>();

  const checkPath = (path: string, source: string) => {
    if (pathMap.has(path)) {
      console.error(`❌ Ruta duplicada encontrada: "${path}"`);
      console.error(`   - Primera definición: ${pathMap.get(path)}`);
      console.error(`   - Segunda definición: ${source}`);
      throw new Error(`Ruta duplicada encontrada: "${path}"`);
    }
    pathMap.set(path, source);
  };

  const processRoutes = (routes: RouteObject[], source: string) => {
    routes.forEach((route) => {
      if (route.path) {
        checkPath(route.path, source);
      }
      if (route.children) {
        processRoutes(route.children, `${source} > ${route.path || "root"}`);
      }
    });
  };

  processRoutes(routes, "rutas principales");
};

if (process.env.NODE_ENV === "development") {
  try {
    validateDuplicatePaths([
      ...PublicRoutes,
      ...PublicLegacyRoutes,
      ...MemberRoutes,
      ...StaffRoutes,
      ...StaffLegacyRoutes,
      ...MemberLegacyRoutes,
      ...DataAdminRoutes,
    ]);
  } catch (error) {
    console.error("Error en la validación de rutas:", error);
  }
}

const protectedSuperAdminRoutes = protectRoutes(SuperAdminRoutes, [
  AccessTypeWithStaff.wsgSuper,
]);
const protectedStaffRoutes = protectRoutes(StaffRoutes, [
  AccessTypeWithStaff.wsgStaff,
]);
const protectedStaffLegacyRoutes = protectRoutes(StaffLegacyRoutes, [
  AccessTypeWithStaff.wsgStaff,
]);
const protectedMemberRoutes = protectRoutes(MemberRoutes, [
  AccessTypeWithStaff.wsgStaff,
  AccessTypeWithStaff.dataAdmin,
  AccessTypeWithStaff.member,
]);
const protectedMemberLegacyRoutes = protectRoutes(MemberLegacyRoutes, [
  AccessTypeWithStaff.wsgStaff,
  AccessTypeWithStaff.dataAdmin,
  AccessTypeWithStaff.member,
]);
const protectedAdminLegacyRoutes = protectRoutes(
  AdminLegacyRoutes,
  [AccessTypeWithStaff.dataAdmin],
  true,
);
const protectedDataAdminRoutes = protectRoutes(DataAdminRoutes, [
  AccessTypeWithStaff.wsgSuper,
  AccessTypeWithStaff.wsgStaff,
  AccessTypeWithStaff.dataAdmin,
]);

export const routes: RouteObject[] = [
  ...protectedMemberRoutes,
  ...protectedStaffLegacyRoutes,
  ...protectedMemberLegacyRoutes,
  ...PublicRoutes,
  ...PublicLegacyRoutes,
  ...protectedSuperAdminRoutes,
  ...protectedStaffRoutes,
  ...protectedAdminLegacyRoutes,
  ...protectedDataAdminRoutes,
  {
    path: "*",
    element: <NotFound />,
  },
];
